import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getUnseenNotificationCount = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/notifications/seen/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const sendNotification = ({ payload, version = 'v1' }) => {
  client
    .request({
      url: `${version}/notifications/generate-notification/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getNotificationList = async ({ params, version = 'v1' }) => {
  client
    .request({
      url: `${version}/notifications/notification/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

export const getNotificationSubscription = async ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/notifications/notification-subscription-preferences/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteNotificationSubscription = ({ id, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/notifications/notification-subscription-preferences/${id}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createNotificationSubscription = ({ data, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/notifications/notification-subscription-preferences/`,
      method: RequestMethod.POST,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateNotificationSubscription = ({ id, data, version = 'v1' }) =>
  client
    .request({
      url: `${version}/notifications/notification-subscription-preferences/${id}/`,
      method: RequestMethod.PATCH,
      data,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getNotificationCatalog = async ({ params, version = 'v1' }) =>
  client
    .request({
      url: `${version}/notifications/notifications-types/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
